import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { guardOpt, teamOpt, sectorOpt } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className="space-y-4">
                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart ? new Date(filters.dtStart) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputForm
                        label="Guarnição"
                        value={filters.garrison}
                        onChange={({target}) => setFilters(prev => ({ ...prev, garrison: target.value }))}
                        instanceId="garrison"
                        id="garrison"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <SelectComponent
                        label='Contingentes'
                        isMulti={true}
                        wrapValues={true}
                        options={guardOpt}
                        value={filters.guard}
                        onChange={(value) => setFilters(prev => ({...prev, guard: value}))}
                        instanceId="guard"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Equipe'
                        isMulti={true}
                        wrapValues={true}
                        options={teamOpt}
                        value={filters.team}
                        onChange={(value) => setFilters(prev => ({...prev, team: value}))}
                        instanceId="team"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Setor'
                        isMulti={true}
                        wrapValues={true}
                        options={sectorOpt}
                        value={filters.sector}
                        onChange={(value) => setFilters(prev => ({...prev, sector: value}))}
                        instanceId="sector"
                        classNameWrapper={"w-full"}
                    />
                </form>
            </div>
        </>
    );
};

export default Filters;